var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSiteLoadDone && _vm.site
    ? _c(
        "div",
        [
          _vm.site.isMenuHorizontalStyle && _vm.staticMenuItemList.length !== 0
            ? _c(
                "div",
                {
                  staticClass:
                    "horizontal-menu-grey-zone d-flex flex-wrap justify-content-end align-items-center"
                },
                _vm._l(_vm.staticMenuItemList, function(menuItem) {
                  return _c(
                    "li",
                    {
                      key: menuItem.id + "_staticMenuItem",
                      staticClass:
                        "nav-item d-flex align-items-center h-100 cursor-pointer"
                    },
                    [
                      menuItem.isOuterLink
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "h-100 w-100 d-flex align-items-center justify-content-between",
                              attrs: { href: menuItem.link, target: "_blank" }
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(menuItem.name) +
                                  "\n      "
                              )
                            ]
                          )
                        : _c(
                            "router-link",
                            {
                              staticClass:
                                "h-100 w-100 d-flex align-items-center justify-content-between",
                              attrs: { to: menuItem.link }
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(menuItem.name) +
                                  "\n      "
                              )
                            ]
                          )
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("header", { staticClass: "header" }, [
            _c("div", { staticClass: "d-flex h-100" }, [
              !_vm.isMobileSearchOpen
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-6 d-flex justify-content-start pl-3 pl-lg-5",
                      class: _vm.site.isMenuHorizontalStyle
                        ? "col-md-2"
                        : "col-md-3"
                    },
                    [
                      _vm.isMobile || !_vm.site.isMenuHorizontalStyle
                        ? _c(
                            "div",
                            {
                              staticClass: "h-100 d-flex align-items-center",
                              on: { click: _vm.toggleMegaMenu }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "mega-menu-icon cursor-pointer",
                                  class: {
                                    open: _vm.isMegaMenuOpen,
                                    "badge-after upper-corner":
                                      _vm.isMobile &&
                                      _vm.unreadMessagesCount > 0
                                  }
                                },
                                [
                                  _c("span"),
                                  _vm._v(" "),
                                  _c("span"),
                                  _vm._v(" "),
                                  _c("span"),
                                  _vm._v(" "),
                                  _c("span")
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.site.logoSrc
                        ? _c(
                            "router-link",
                            {
                              staticClass: "d-flex align-items-center w-100",
                              class: {
                                "ml-4":
                                  _vm.isMobile ||
                                  !_vm.site.isMenuHorizontalStyle
                              },
                              attrs: { to: "/", "aria-label": "Home" }
                            },
                            [
                              _c("div", {
                                staticClass: "d-flex logo w-100",
                                style: {
                                  "background-image":
                                    "url(" + _vm.site.logoSrc + ")"
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobile && _vm.isMobileSearchOpen
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-6 d-flex justify-content-center"
                    },
                    [
                      _c("header-search", {
                        class: {
                          "w-75": !_vm.isMobile,
                          "w-100 col-12": _vm.isMobile
                        },
                        on: { closeSearch: _vm.closeSearch }
                      })
                    ],
                    1
                  )
                : !_vm.isMobile
                ? _c(
                    "div",
                    {
                      staticClass: "col-12 d-flex justify-content-center",
                      class: _vm.site.isMenuHorizontalStyle
                        ? "col-md-8"
                        : "col-md-6"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "position-relative d-flex align-items-center justify-content-center",
                          class: {
                            "header-search-visible":
                              _vm.isHorizontalStyleMenuSearchOpen,
                            "header-search-container":
                              _vm.site.isMenuHorizontalStyle,
                            "w-100": !_vm.site.isMenuHorizontalStyle
                          }
                        },
                        [
                          _c("header-search", {
                            class: {
                              "w-75": !_vm.isMobile,
                              "w-100 col-12": _vm.isMobile
                            },
                            on: { closeSearch: _vm.closeSearch }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.site.isMenuHorizontalStyle
                        ? _c(
                            "div",
                            {
                              staticClass: "position-absolute h-100 w-100",
                              class: {
                                "with-grey-bar":
                                  _vm.staticMenuItemList.length !== 0
                              }
                            },
                            [
                              _c("mega-menu", {
                                attrs: { "is-mega-menu-open": true }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMobileSearchOpen
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-6 d-flex justify-content-end align-items-center pr-4 pr-lg-5",
                      class: {
                        "header-action-container col-md-2":
                          _vm.site.isMenuHorizontalStyle,
                        "header-action-container col-md-3": !_vm.site
                          .isMenuHorizontalStyle
                      }
                    },
                    [
                      !_vm.isMobile && _vm.site.isMenuHorizontalStyle
                        ? _c("div", {
                            staticClass: "mr-3 cursor-pointer",
                            class: _vm.isHorizontalStyleMenuSearchOpen
                              ? "close-icon"
                              : "header-search-icon",
                            on: {
                              click: function($event) {
                                _vm.isHorizontalStyleMenuSearchOpen = !_vm.isHorizontalStyleMenuSearchOpen
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoggedIn
                        ? _c("router-link", {
                            staticClass:
                              "header-icon user mr-4 d-none d-md-block",
                            class: {
                              "ml-2": _vm.site.isMenuHorizontalStyle
                            },
                            attrs: {
                              to: "/login",
                              "aria-label": _vm.$t("belepes_vagy_regisztracio")
                            }
                          })
                        : _c(
                            "b-dropdown",
                            {
                              staticClass:
                                "header-profile-dropdown mr-2 d-none d-md-block",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button-content",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "w-100 h-100",
                                            class: {
                                              "badge-after":
                                                _vm.unreadMessagesCount > 0
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "avatar mr-2",
                                              attrs: {
                                                src: _vm.user.avatarSrc,
                                                alt: _vm.$t("profilom")
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2233552533
                              )
                            },
                            [
                              _vm._v(" "),
                              _vm.site.isMenuHorizontalStyle
                                ? [
                                    _c(
                                      "b-dropdown-item",
                                      { attrs: { disabled: "" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "py-2 d-flex" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mr-4 position-relative"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "avatar large-size",
                                                  attrs: {
                                                    src: _vm.user.avatarLargeSrc
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "ml-4 text-center"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "font-weight-bold",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.user.username
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.user.userPoint +
                                                        " " +
                                                        _vm.$t("term_pont")
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      { on: { click: _vm.goToProfileTab } },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "dropdown-navigation-link",
                                            attrs: {
                                              to: {
                                                name:
                                                  _vm.pageNames
                                                    .PAGE_PROFILE_MY_PROFILE,
                                                query: {
                                                  tab: "personal",
                                                  subTab: "personal"
                                                }
                                              },
                                              "aria-label": _vm.$t("profilom")
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "py-2 d-flex justify-content-between w-100"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center"
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "dropdown-icon mr-2 personal-details"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      directives: [
                                                        {
                                                          name: "t",
                                                          rawName: "v-t",
                                                          value: "profilom",
                                                          expression:
                                                            "'profilom'"
                                                        }
                                                      ],
                                                      attrs: {
                                                        "data-cy": "profile-btn"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.unreadMessagesCount > 0
                                                  ? _c("div", {
                                                      staticClass:
                                                        "badge-large",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.unreadMessagesCount
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "dropdown-navigation-link",
                                            attrs: {
                                              to: {
                                                name:
                                                  _vm.pageNames
                                                    .PAGE_PROFILE_MY_PROFILE,
                                                query: { tab: "order" }
                                              },
                                              "aria-label": _vm.$t(
                                                "rendeleseim"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "py-2 d-flex align-items-center w-100"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-icon mr-2 orders"
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value: "rendeleseim",
                                                      expression:
                                                        "'rendeleseim'"
                                                    }
                                                  ]
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "dropdown-navigation-link",
                                            attrs: {
                                              to: {
                                                name:
                                                  _vm.pageNames
                                                    .PAGE_PROFILE_MY_PROFILE,
                                                query: { tab: "favorite" }
                                              },
                                              "aria-label": _vm.$t(
                                                "menu_shop_kedvencek"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "py-2 d-flex align-items-center w-100"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-icon mr-2 favorites"
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value:
                                                        "menu_shop_kedvencek",
                                                      expression:
                                                        "'menu_shop_kedvencek'"
                                                    }
                                                  ]
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "dropdown-navigation-link",
                                            attrs: {
                                              to: {
                                                name:
                                                  _vm.pageNames
                                                    .PAGE_PROFILE_MY_PROFILE,
                                                query: { tab: "messages" }
                                              },
                                              "aria-label": _vm.$t("uzeneteim")
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "py-2 d-flex align-items-center w-100"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-icon mr-2 messages"
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value: "uzeneteim",
                                                      expression: "'uzeneteim'"
                                                    }
                                                  ]
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "dropdown-navigation-link",
                                            attrs: {
                                              to: {
                                                name:
                                                  _vm.pageNames
                                                    .PAGE_PROFILE_MY_PROFILE,
                                                query: { tab: "questions" }
                                              },
                                              "aria-label": _vm.$t(
                                                "termekkerdeseim"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "py-2 d-flex align-items-center w-100"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-icon mr-2 questions"
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value: "termekkerdeseim",
                                                      expression:
                                                        "'termekkerdeseim'"
                                                    }
                                                  ]
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      { on: { click: _vm.goToDiscountTab } },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "dropdown-navigation-link",
                                            attrs: {
                                              to: {
                                                name:
                                                  _vm.pageNames
                                                    .PAGE_PROFILE_MY_PROFILE,
                                                query: {
                                                  tab: "personal",
                                                  subTab: "discount"
                                                }
                                              },
                                              "aria-label": _vm.$t(
                                                "husegpontok"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "py-2 d-flex align-items-center w-100"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-icon mr-2 points"
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value: "husegpontok",
                                                      expression:
                                                        "'husegpontok'"
                                                    }
                                                  ]
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      { on: { click: _vm.userLogout } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-navigation-link d-flex align-items-center",
                                            attrs: { "data-cy": "logout-btn" }
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "dropdown-icon mr-2 logout"
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "kilepes",
                                                  expression: "'kilepes'"
                                                }
                                              ],
                                              staticClass: "py-2"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _c(
                                      "b-dropdown-item",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "dropdown-navigation-link",
                                            attrs: {
                                              to: {
                                                name: "myprofile",
                                                query: { tab: "personal" }
                                              },
                                              "aria-label": _vm.$t("profilom")
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "py-2 d-flex justify-content-between w-100"
                                              },
                                              [
                                                _c("div", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value: "profilom",
                                                      expression: "'profilom'"
                                                    }
                                                  ],
                                                  attrs: {
                                                    "data-cy": "profile-btn"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm.unreadMessagesCount > 0
                                                  ? _c("div", {
                                                      staticClass:
                                                        "badge-large",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.unreadMessagesCount
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      { on: { click: _vm.userLogout } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-navigation-link",
                                            attrs: { "data-cy": "logout-btn" }
                                          },
                                          [
                                            _c("div", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "kilepes",
                                                  expression: "'kilepes'"
                                                }
                                              ],
                                              staticClass: "py-2"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                            ],
                            2
                          ),
                      _vm._v(" "),
                      _vm.isMobile
                        ? _c("div", {
                            staticClass:
                              "header-icon search cursor-pointer mr-4",
                            on: { click: _vm.openMobileSearch }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.site && _vm.site.isShopSite
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.cart-collapse",
                                  modifiers: { "cart-collapse": true }
                                }
                              ],
                              staticClass: "header-icon cart cursor-pointer"
                            },
                            [
                              _c("div", {
                                staticClass: "cart-badge",
                                domProps: {
                                  textContent: _vm._s(_vm.cartItemCount)
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("breadcrumb"),
          _vm._v(" "),
          _vm.site.isShopSite && !_vm.isOnCheckoutPage
            ? _c("cart", {
                on: {
                  isCartVisible: function($event) {
                    return _vm.sendCartViewEvent($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }